import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { servicesData } from '../data/services'; // Ensure this path is correct!
import SEO from '../components/SEO';

const ServicesPage = () => {
  return (
    <>
    <SEO
        title="All Signage Solutions & Vehicle Graphics | A2Z Signs"
        description="Explore our complete range of high-quality business signage. A2Z Signs designs, fabricates, and installs everything from wall graphics to giant pylon signs."
        keywords="all signage services, custom business signs, commercial sign fabrication, sign installation, fleet wraps, digital signs"
      />

    <div className="pt-32 pb-24 min-h-screen bg-brand-light">
      <div className="container mx-auto px-6 md:px-12">
        
        {/* Header */}
        <div className="text-center mb-16">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-5xl font-heading font-extrabold text-brand-dark mb-4"
          >
            Our <span className="text-brand-blue">Signage Solutions</span>
          </motion.h1>
          <div className="w-24 h-1 bg-brand-cyan mx-auto rounded-full mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Explore our comprehensive range of custom signage services. Click on any service to learn more.
          </p>
        </div>

        {/* Grid of 40 Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {servicesData.map((service, index) => (
            <motion.div
              key={service.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: (index % 8) * 0.1 }} // Staggers animation slightly
            >
              <Link 
                to={`/services/${service.id}`}
                className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden flex flex-col h-full group hover:shadow-xl hover:-translate-y-2 transition-all duration-300"
              >
                {/* Card Image */}
                <div className="w-full h-48 overflow-hidden relative">
                  <div className="absolute inset-0 bg-brand-dark/20 group-hover:bg-transparent transition-colors duration-500 z-10"></div>
                  <img 
                    src={service.image} 
                    alt={service.title} 
                    className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110"
                  />
                </div>
                
                {/* Card Text */}
                <div className="p-6 flex flex-col flex-grow">
                  <h3 className="text-xl font-heading font-bold text-brand-dark mb-3 group-hover:text-brand-blue transition-colors">
                    {service.title}
                  </h3>
                  {/* Shows just a snippet of the first paragraph */}
                  <p className="text-gray-500 text-sm mb-6 line-clamp-3 flex-grow">
                    {service.paragraphs[0]}
                  </p>
                  
                  <div className="mt-auto flex items-center text-brand-cyan font-bold text-sm uppercase tracking-wider group-hover:text-brand-blue transition-colors">
                    Learn More <ArrowRight size={16} className="ml-2 transform group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>

      </div>
    </div>
    </>
  );
};

export default ServicesPage;